<template>
  <transition :appear="appear" :name="handleTransitionName()" @after-leave="$emit('afterLeave')"><slot /></transition>
</template>

<script lang="ts">
import { isMobile } from '@/util/dom-utils'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NSidebarTransition extends Vue {
  @Prop({ type: Boolean }) appear?: boolean

  handleTransitionName(): string {
    return isMobile() ? 'slide-in-from-bottom' : 'slide-in-to-left'
  }
}
</script>

<style scoped lang="scss">
.slide-in-to-left-enter-active,
.slide-in-to-left-leave-active {
  transition: width 0.3s;
}
.slide-in-to-left-enter, .slide-in-to-left-leave-to /* .fade-leave-active below version 2.1.8 */ {
  width: 0 !important;
}

.slide-in-from-bottom-enter-active,
.slide-in-from-bottom-leave-active {
  transition: height 0.3s ease-in;
}
.slide-in-from-bottom, .slide-in-from-bottom-leave-to /* .fade-leave-active below version 2.1.8 */ {
  height: 0 !important;
}
</style>
